import { defineComponent, reactive } from "vue";
import { api } from "~/api";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { PageID } from "~/extensions/utils/DefineTypes";
import { commonStore } from "~/store/CommonStore";
import { myPageStore } from "~/store/MyPageStore";
const log = Log.create("ShomeiEntryComplete");
export default defineComponent({
    components: {
        BreadcrumbList
    },
    name: "ShomeiEntryCompletePage",
    beforeRouteEnter(to, from, next) {
        if (from.name === "shomei-shinsei-entry-check" || !from.name) {
            next();
            return;
        }
        next(false);
    },
    async setup() {
        // 画面名取得
        const pageName = commonStore.pageName(PageID.shomeiEntryComplete);
        let html = reactive({
            value: ""
        });
        const isMultipleKeiyaku = myPageStore.isMultipleKeiyaku;
        // 初期表示処理
        const initView = async () => {
            try {
                let result = await api.shomei.loadEntryCompleteText();
                html.value = result;
            }
            catch (ex) {
                log.error("setup", ex);
                MsgBox.error(ex.message);
            }
        };
        initView();
        return {
            pageName,
            PageID,
            html,
            isMultipleKeiyaku
        };
    }
});
